export default __webpack_public_path__ + "static/media/teamwork.23bd24b1.svg";